/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "E6E4AC32-C8A1-48A0-BD7C-BB133F9DE619",
  "sitecoreApiHost": "",
  "jssAppName": "ActumDigital",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/ActumDigital",
  "graphQLEndpoint": "/api/ActumDigital?sc_apikey=E6E4AC32-C8A1-48A0-BD7C-BB133F9DE619"
};